/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// components
import TabPanel from '../../components/tabPanel'
import BulkUsersUpload from './components/bulkUsersUpload'
import UserForm from '../../components/userForm'
import Breadcrumbs from '../../components/Breadcrumbs'
import ConfirmationDialog from '../../components/confirmationDialog'

// constants
import {
  USER_INITIAL_STATE,
  CREATE_FORM_FIELDS_CONFIG,
  DISABLED_BULK_FOR_TENANTS,
} from './createUser.constants'

// helpers
import {
  makeCreateUserDTO,
  getSelectedGroupsCount,
  areFormValuesChanged,
} from './createUser.helpers'
import { removeEmptyProperties } from '../../helpers/general'
import { isSuperAdmin } from '../../helpers/user'

// hooks
import useDialogVisibility from '../../hooks/useDialogVisibility'

//services
import { createUser } from '../../services/user'
import { validateUserSubmit, hasJnjGroupAccess } from '../../components/userForm/helpers/userForm.validators'

//styles
import styles from './createUser.module.scss'

// regex that prevents its.jnj.com email but accepts all others  
const CREATE_EMAIL_REGEX = /^(?!.*its\.jnj\.com$)[^\s@]+@[^\s@]+\.[a-zA-Z]{1,}$/;

function CreateUser() {
  const location = useLocation()
  const superAdmin = isSuperAdmin()
  const { t } = useTranslation()
  const jnjGroupAccess = hasJnjGroupAccess()
  const navigate = useNavigate()
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [user, setUser] = useState(USER_INITIAL_STATE)
  const [errors, setErrors] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [
    isCancelConfirmationDialogOpen,
    openCancelConfirmationDialog,
    closeCancelConfirmationDialog,
  ] = useDialogVisibility(false)

  const breadcrumbPath = [
    {label: 'users-create-tab'},
  ]

  const handleTabChange = (event, index) => {
    setSelectedTabIndex(index)
  }

  const handleCreateUserSuccess = () => {
    setUser(USER_INITIAL_STATE)
    setErrors({})
    toast.success('User created successfully')
  }

  const handleCreateUserFailure = (error) => {
    toast.error(error?.message)
  }

  const setAsSubmitted = () => setIsSubmitting(false)

  const onSubmit = () => {
    const errorMsgs = validateUserSubmit(user, CREATE_EMAIL_REGEX, (jnjGroupAccess || superAdmin) );
    if (Object.keys(removeEmptyProperties(errorMsgs)).length >= 1) {
      setErrors(errorMsgs)
      return
    }
    setIsSubmitting(true)
    const userDTO = makeCreateUserDTO(user)
    createUser(userDTO)
      .then(handleCreateUserSuccess)
      .catch(handleCreateUserFailure)
      .finally(setAsSubmitted)
  }

  const onCancel = () => {
    openCancelConfirmationDialog()
  }

  const handleSubmitCancelConfirmationDialog = () => {
    setErrors({})
    setUser(USER_INITIAL_STATE)
    closeCancelConfirmationDialog()
    window.scrollTo({ top: 0 })
    navigate('/')
  }
  const areUserValuesChanged = areFormValuesChanged(user)

  const loggedInTenant = localStorage.getItem('tenant');
  const isButtonDisabled = DISABLED_BULK_FOR_TENANTS.includes(loggedInTenant);

  useEffect(() => {
      if (location.state && location.state.selectedTabIndex) {
        setSelectedTabIndex(location.state.selectedTabIndex)
      }
  }, [location.state]);

  return (
    <Box className={styles.container}>
      <div className={styles.pageHeader}>
        <Breadcrumbs crumbs={breadcrumbPath}/>
      </div>
      <Tabs
        //centered
        sx={{backgroundColor: '#F5F5F5', borderBottom: '4px solid #D9D9D9', justifyContent: 'left', paddingLeft: {md: '115px'} }}
        TabIndicatorProps={{
          sx: {
            backgroundColor: '#EB1700',
            height: '4px',
          },
        }}
        value={selectedTabIndex}
        onChange={handleTabChange}
      >
        <Tab label={t('user-single-user-tab')} className={styles.tabLabel} style={{width:'197px'}} />
        <Tab label={t('user-bulk-user-tab')} className={styles.tabLabel} style={{width:'275px'}} />
      </Tabs>

      <TabPanel
        className={styles.panel}
        value={selectedTabIndex}
        index={0}
        sx={{ width: '50%' }}
      >
        <UserForm
          user={user}
          setUser={setUser}
          errors={errors}
          setErrors={setErrors}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          onCancel={onCancel}
          formFieldsConfig={CREATE_FORM_FIELDS_CONFIG}
          getSelectedGroupsCount={getSelectedGroupsCount}
          areFormValuesChanged={areUserValuesChanged}
          groupsModalInfo="You cannot Add more than 5 groups"
          emailRegex ={CREATE_EMAIL_REGEX}
          isCreateUser={true}
        />
      </TabPanel>
      <TabPanel value={selectedTabIndex} index={1} sx={{ width: '50%' }}>
        <BulkUsersUpload />
      </TabPanel>
      <ConfirmationDialog
        showDialog={isCancelConfirmationDialogOpen}
        onSubmit={handleSubmitCancelConfirmationDialog}
        onCancel={closeCancelConfirmationDialog}
      />
    </Box>
  )
}

export default CreateUser
